import _extends from 'babel-runtime/helpers/extends';
import { connect } from 'react-redux';
import { stepStatusActions } from '../redux/step-status-reducer';

var mapStateToProps = function mapStateToProps(state) {
  return state.stepStatus;
};

var mapDispatchToProps = {
  startActivityStep: stepStatusActions.startActivityStep,
  updateStepStatus: stepStatusActions.updateStepStatus,
  activityStepTryAgainSelected: stepStatusActions.activityStepTryAgainSelected,
  goToNextPronunciationItem: stepStatusActions.goToNextPronunciationItem,
  pronunciationItemAttempted: stepStatusActions.pronunciationItemAttempted,
  submitActivityStep: stepStatusActions.submitActivityStep,
  skipActivityStep: stepStatusActions.skipActivityStep,
  activityStepMediaStarted: stepStatusActions.activityStepMediaStarted,
  activityStepMediaPaused: stepStatusActions.activityStepMediaPaused,
  activityStepMediaFinished: stepStatusActions.activityStepMediaFinished,
  activityStepDismissed: stepStatusActions.activityStepDismissed,
  setCompleteActivityStepOnDismissPayload: stepStatusActions.setCompleteActivityStepOnDismissPayload
};

var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, {
    stepStatus: _extends({}, stateProps, dispatchProps)
  });
};

export var withStepStatus = connect(mapStateToProps, mapDispatchToProps, mergeProps);